import { IDotDongTuiActionTypes } from "../../action-types/tct/IDotDongTuiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotDongTuiReducer } from "../../reducer-model/tct/IDotDongTuiReducer";
const iniState: IDotDongTuiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dotDongTuis: [],
  nam_hoc: "",
  hoc_ky: 0,
  selectedIds: []
};
export const dotDongTuiReducer = (
  state: IDotDongTuiReducer = iniState,
  action: IDotDongTuiActionTypes
): IDotDongTuiReducer => {
  switch (action.type) {
    case "DOT_DONG_TUI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nam_hoc: action.payload,
        selectedIds: []
      };
    case "DOT_DONG_TUI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dotDongTuis: action.payload,
      };
    case "DOT_DONG_TUI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_DONG_TUI_SHOW_EDIT_MODAL":
      return {
        ...state,
        dotDongTuiEditing: action.payload,
        isShowEditModal: true
      };
    case "DOT_DONG_TUI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "DOT_DONG_TUI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "DOT_DONG_TUI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "DOT_DONG_TUI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "DOT_DONG_TUI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "DOT_DONG_TUI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "DOT_DONG_TUI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "DOT_DONG_TUI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
